import { PublicMobileShell } from "../components/PublicMobileShell";
import { Card, CardContent } from "../components/ui/card";
import { Mail, HelpCircle } from "lucide-react";

const FAQ = [
  { q: "Kako se pridružim lovu?", a: "V zavihku »Lovi« vnesite kodo lova ali skenirajte QR kodo vodje." },
  { q: "Zakaj ne vidim lokacije?", a: "Omogočite dostop do lokacije v nastavitvah telefona." },
  { q: "Kaj vključuje Pro?", a: "Offline karte, radar padavin in več; 14-dnevni brezplačni preizkus letne naročnine." },
  { q: "Kako prekličem naročnino?", a: "Nastavitve App Store (iOS) oz. Google Play (Android) → Naročnine." },
  { q: "Kako izbrišem račun?", a: "V aplikaciji: Profil → »Izbriši račun« (trajno izbriše račun in podatke)." },
];

export default function PodporaPage() {
  return (
    <PublicMobileShell>
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16 space-y-8" data-testid="podpora-page">
        <div className="text-center space-y-3">
          <h1 className="text-4xl sm:text-5xl font-bold text-emerald-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            Dober Pogled — Podpora
          </h1>
          <p className="text-base md:text-lg text-slate-600">Pomoč za mobilno aplikacijo za lovce (iOS in Android)</p>
        </div>

        <Card data-testid="podpora-kontakt">
          <CardContent className="pt-6 flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-emerald-900/10 flex items-center justify-center shrink-0">
              <Mail className="h-5 w-5 text-emerald-900" />
            </div>
            <div>
              <h2 className="font-semibold text-emerald-900 mb-1">Kontakt</h2>
              <p className="text-sm text-slate-600">
                Pišite na{" "}
                <a href="mailto:info@doberpogled.app" className="text-emerald-900 font-medium hover:underline">info@doberpogled.app</a>
                {" "}— odgovorimo v 1–2 delovnih dneh.
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="space-y-3" data-testid="podpora-faq">
          <h2 className="font-semibold text-emerald-900 flex items-center gap-2 text-lg">
            <HelpCircle className="h-5 w-5" /> Pogosta vprašanja
          </h2>
          {FAQ.map((f) => (
            <Card key={f.q}>
              <CardContent className="pt-5 pb-5">
                <h3 className="font-semibold text-emerald-900 text-sm mb-1">{f.q}</h3>
                <p className="text-sm text-slate-600">{f.a}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </PublicMobileShell>
  );
}
